import { FC } from 'react';
import { Card, Button, Table } from 'react-daisyui';

const CompanyAdminsPage: FC = () => {
  // This would normally fetch data from an API
  const admins = [
    { id: 1, name: 'John Doe', email: 'john@company.com', role: 'Super Admin', status: 'Active' },
    { id: 2, name: 'Jane Smith', email: 'jane@company.com', role: 'Admin', status: 'Active' },
  ];

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <h1 className="text-3xl font-bold">Company Admins</h1>
        <Button color="primary">Add Admin</Button>
      </div>

      <Card className="bg-base-100 shadow-xl">
        <Card.Body>
          <Table className="w-full">
            <Table.Head>
              <span>Name</span>
              <span>Email</span>
              <span>Role</span>
              <span>Status</span>
              <span>Actions</span>
            </Table.Head>
            <Table.Body>
              {admins.map((admin) => (
                <Table.Row key={admin.id}>
                  <span>{admin.name}</span>
                  <span>{admin.email}</span>
                  <span>{admin.role}</span>
                  <span>
                    <span className="badge badge-success">{admin.status}</span>
                  </span>
                  <span>
                    <Button size="sm" color="ghost">Edit</Button>
                  </span>
                </Table.Row>
              ))}
            </Table.Body>
          </Table>
        </Card.Body>
      </Card>
    </div>
  );
};

export default CompanyAdminsPage;

